import { useEffect, useState } from "react"

export const useEmailValidation = (email='') => {
    const [isEmailValid, setIsEmailValid] = useState(null)
    useEffect(()=>{
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setIsEmailValid( re.test(email)?true:false) 
    },[email])
    return isEmailValid;
}